/**
 * Production ticket (talão) — a planned slice of a production order
 * (spec 0040 §2.5 / request 0171).
 *
 * Top-level collection: org/{orgId}/production-ticket (not a subcollection).
 * Transactional: Auditable, no Inactivatable — the only lifecycle is `status`.
 * Never created freely: only via `productionTicketService.generateTickets`.
 *
 * `ticketNumber` is a snapshot at generation (`{code}-{sequence}`).
 * Renaming the OP later does not rewrite existing tickets.
 *
 * No size breakdown (D4) — a future `ProductionTicketBreakdown` is additive.
 */
export const PRODUCTION_TICKET = 'ProductionTicket';
export const ProductionTicketStatusValues = [
    'open',
    'in-progress',
    'done',
    'cancelled',
];
export const PRODUCTION_TICKET_STATUS_LABELS = {
    open: 'Aberto',
    'in-progress': 'Em andamento',
    done: 'Concluído',
    cancelled: 'Cancelado',
};
//# sourceMappingURL=production-ticket.js.map